export default [
  {alpha: 'GH', name: '가나'},
  {alpha: 'GA', name: '가봉'},
  {alpha: 'GY', name: '가이아나'},
  {alpha: 'GM', name: '감비아'},
  {alpha: 'GG', name: '건지'},
  {alpha: 'GP', name: '과들루프'},
  {alpha: 'GT', name: '과테말라'},
  {alpha: 'GU', name: '괌'},
  {alpha: 'GD', name: '그레나다'},
  {alpha: 'GR', name: '그리스'},
  {alpha: 'GL', name: '그린란드'},
  {alpha: 'GN', name: '기니'},
  {alpha: 'GW', name: '기니비사우'},
  {alpha: 'NA', name: '나미비아'},
  {alpha: 'NR', name: '나우루'},
  {alpha: 'NG', name: '나이지리아'},
  {alpha: 'AQ', name: '남극 대륙'},
  {alpha: 'SS', name: '남수단'},
  {alpha: 'ZA', name: '남아프리카 공화국'},
  {alpha: 'NL', name: '네덜란드'},
  {alpha: 'NP', name: '네팔'},
  {alpha: 'NO', name: '노르웨이'},
  {alpha: 'NF', name: '노퍽 섬'},
  {alpha: 'NZ', name: '뉴질랜드'},
  {alpha: 'NC', name: '뉴칼레도니아'},
  {alpha: 'NU', name: '니우에'},
  {alpha: 'NE', name: '니제르'},
  {alpha: 'NI', name: '니카라과'},
  {alpha: 'TW', name: '대만'},
  {alpha: 'KR', name: '대한민국'},
  {alpha: 'DK', name: '덴마크'},
  {alpha: 'DM', name: '도미니카'},
  {alpha: 'DO', name: '도미니카 공화국'},
  {alpha: 'DE', name: '독일'},
  {alpha: 'TL', name: '동티모르'},
  {alpha: 'LA', name: '라오스'},
  {alpha: 'LR', name: '라이베리아'},
  {alpha: 'LV', name: '라트비아'},
  {alpha: 'LB', name: '레바논'},
  {alpha: 'LS', name: '레소토'},
  {alpha: 'RE', name: '레위니옹'},
  {alpha: 'RO', name: '루마니아'},
  {alpha: 'LU', name: '룩셈부르크'},
  {alpha: 'RW', name: '르완다'},
  {alpha: 'LY', name: '리비아'},
  {alpha: 'LT', name: '리투아니아'},
  {alpha: 'LI', name: '리히텐슈타인'},
  {alpha: 'MG', name: '마다가스카르'},
  {alpha: 'MQ', name: '마르티니크'},
  {alpha: 'MH', name: '마셜 제도'},
  {alpha: 'YT', name: '마요트'},
  {alpha: 'MO', name: '마카오'},
  {alpha: 'MW', name: '말라위'},
  {alpha: 'MY', name: '말레이시아'},
  {alpha: 'ML', name: '말리'},
  {alpha: 'IM', name: '맨 섬'},
  {alpha: 'MX', name: '멕시코'},
  {alpha: 'MC', name: '모나코'},
  {alpha: 'MA', name: '모로코'},
  {alpha: 'MU', name: '모리셔스'},
  {alpha: 'MR', name: '모리타니'},
  {alpha: 'MZ', name: '모잠비크'},
  {alpha: 'ME', name: '몬테네그로'},
  {alpha: 'MS', name: '몬트세라트'},
  {alpha: 'MD', name: '몰도바'},
  {alpha: 'MV', name: '몰디브'},
  {alpha: 'MT', name: '몰타'},
  {alpha: 'MN', name: '몽골'},
  {alpha: 'US', name: '미국'},
  {alpha: 'UM', name: '미국령 군소 제도'},
  {alpha: 'VI', name: '미국령 버진아일랜드'},
  {alpha: 'AS', name: '미국령 사모아'},
  {alpha: 'MM', name: '미얀마'},
  {alpha: 'FM', name: '미크로네시아'},
  {alpha: 'VU', name: '바누아투'},
  {alpha: 'BH', name: '바레인'},
  {alpha: 'BB', name: '바베이도스'},
  {alpha: 'VA', name: '바티칸 시국'},
  {alpha: 'BS', name: '바하마'},
  {alpha: 'BD', name: '방글라데시'},
  {alpha: 'BM', name: '버뮤다'},
  {alpha: 'BJ', name: '베냉'},
  {alpha: 'VE', name: '베네수엘라'},
  {alpha: 'VN', name: '베트남'},
  {alpha: 'BE', name: '벨기에'},
  {alpha: 'BY', name: '벨라루스'},
  {alpha: 'BZ', name: '벨리즈'},
  {alpha: 'BQ', name: '보네르, 신트외스타티우스, 사바'},
  {alpha: 'BA', name: '보스니아 헤르체고비나'},
  {alpha: 'BW', name: '보츠와나'},
  {alpha: 'BO', name: '볼리비아'},
  {alpha: 'BI', name: '부룬디'},
  {alpha: 'BF', name: '부르키나파소'},
  {alpha: 'BV', name: '부베 섬'},
  {alpha: 'BT', name: '부탄'},
  {alpha: 'MP', name: '북마리아나 제도'},
  {alpha: 'MK', name: '북마케도니아'},
  {alpha: 'BG', name: '불가리아'},
  {alpha: 'BR', name: '브라질'},
  {alpha: 'BN', name: '브루나이 다루살람'},
  {alpha: 'WS', name: '사모아'},
  {alpha: 'SA', name: '사우디아라비아'},
  {alpha: 'GS', name: '사우스조지아 사우스 샌드위치 제도'},
  {alpha: 'SM', name: '산마리노'},
  {alpha: 'ST', name: '상투메 프린시페'},
  {alpha: 'BL', name: '생바르텔레미'},
  {alpha: 'PM', name: '생피에르 미클롱'},
  {alpha: 'SN', name: '세네갈'},
  {alpha: 'RS', name: '세르비아'},
  {alpha: 'SC', name: '세이셸'},
  {alpha: 'LC', name: '세인트 루시아'},
  {alpha: 'MF', name: '세인트 마틴(프랑스령)'},
  {alpha: 'VC', name: '세인트 빈센트 그레나딘'},
  {alpha: 'SH', name: '세인트 헬레나'},
  {alpha: 'KN', name: '세인트키츠 네비스'},
  {alpha: 'SO', name: '소말리아'},
  {alpha: 'SB', name: '솔로몬 제도'},
  {alpha: 'SD', name: '수단'},
  {alpha: 'SR', name: '수리남'},
  {alpha: 'LK', name: '스리랑카'},
  {alpha: 'SJ', name: '스발바르얀 마옌 제도'},
  {alpha: 'SE', name: '스웨덴'},
  {alpha: 'CH', name: '스위스'},
  {alpha: 'ES', name: '스페인'},
  {alpha: 'SK', name: '슬로바키아'},
  {alpha: 'SI', name: '슬로베니아'},
  {alpha: 'SY', name: '시리아'},
  {alpha: 'SL', name: '시에라리온'},
  {alpha: 'SX', name: '신트마르턴(네덜란드령)'},
  {alpha: 'SG', name: '싱가포르'},
  {alpha: 'AE', name: '아랍에미리트'},
  {alpha: 'AW', name: '아루바'},
  {alpha: 'AM', name: '아르메니아'},
  {alpha: 'AR', name: '아르헨티나'},
  {alpha: 'IS', name: '아이슬란드'},
  {alpha: 'HT', name: '아이티'},
  {alpha: 'IE', name: '아일랜드'},
  {alpha: 'AZ', name: '아제르바이잔'},
  {alpha: 'AF', name: '아프가니스탄'},
  {alpha: 'AD', name: '안도라'},
  {alpha: 'AL', name: '알바니아'},
  {alpha: 'DZ', name: '알제리'},
  {alpha: 'AO', name: '앙골라'},
  {alpha: 'AG', name: '앤티가 바부다'},
  {alpha: 'AI', name: '앵귈라'},
  {alpha: 'ER', name: '에리트레아'},
  {alpha: 'SZ', name: '에스와티니'},
  {alpha: 'EE', name: '에스토니아'},
  {alpha: 'EC', name: '에콰도르'},
  {alpha: 'ET', name: '에티오피아'},
  {alpha: 'SV', name: '엘살바도르'},
  {alpha: 'GB', name: '영국'},
  {alpha: 'VG', name: '영국령 버진아일랜드'},
  {alpha: 'IO', name: '영국령 인도양 제도'},
  {alpha: 'YE', name: '예멘'},
  {alpha: 'OM', name: '오만'},
  {alpha: 'AU', name: '오스트레일리아'},
  {alpha: 'AT', name: '오스트리아'},
  {alpha: 'HN', name: '온두라스'},
  {alpha: 'AX', name: '올란드'},
  {alpha: 'WF', name: '왈리스 푸투나 제도'},
  {alpha: 'JO', name: '요르단'},
  {alpha: 'UG', name: '우간다'},
  {alpha: 'UY', name: '우루과이'},
  {alpha: 'UZ', name: '우즈베키스탄'},
  {alpha: 'UA', name: '우크라이나'},
  {alpha: 'IQ', name: '이라크'},
  {alpha: 'IR', name: '이란'},
  {alpha: 'IL', name: '이스라엘'},
  {alpha: 'EG', name: '이집트'},
  {alpha: 'IT', name: '이탈리아'},
  {alpha: 'IN', name: '인도'},
  {alpha: 'ID', name: '인도네시아'},
  {alpha: 'JP', name: '일본'},
  {alpha: 'JM', name: '자메이카'},
  {alpha: 'ZM', name: '잠비아'},
  {alpha: 'JE', name: '저지'},
  {alpha: 'GQ', name: '적도 기니'},
  {alpha: 'GE', name: '조지아'},
  {alpha: 'CN', name: '중국'},
  {alpha: 'CF', name: '중앙아프리카공화국'},
  {alpha: 'DJ', name: '지부티'},
  {alpha: 'GI', name: '지브롤터'},
  {alpha: 'ZW', name: '짐바브웨'},
  {alpha: 'TD', name: '차드'},
  {alpha: 'CZ', name: '체코 공화국'},
  {alpha: 'CL', name: '칠레'},
  {alpha: 'CM', name: '카메룬'},
  {alpha: 'CV', name: '카보베르데'},
  {alpha: 'KY', name: '카이만 제도'},
  {alpha: 'KZ', name: '카자흐스탄'},
  {alpha: 'QA', name: '카타르'},
  {alpha: 'KH', name: '캄보디아'},
  {alpha: 'CA', name: '캐나다'},
  {alpha: 'KE', name: '케냐'},
  {alpha: 'KM', name: '코모로'},
  {alpha: 'CR', name: '코스타리카'},
  {alpha: 'CC', name: '코코스(킬링) 제도'},
  {alpha: 'CI', name: '코트디부아르'},
  {alpha: 'CO', name: '콜롬비아'},
  {alpha: 'CG', name: '콩고(공화국)'},
  {alpha: 'CD', name: '콩고민주공화국'},
  {alpha: 'KW', name: '쿠웨이트'},
  {alpha: 'CK', name: '쿡 제도'},
  {alpha: 'CW', name: '퀴라소'},
  {alpha: 'HR', name: '크로아티아'},
  {alpha: 'CX', name: '크리스마스 섬'},
  {alpha: 'KG', name: '키르기스스탄'},
  {alpha: 'KI', name: '키리바시'},
  {alpha: 'CY', name: '키프로스'},
  {alpha: 'TJ', name: '타지키스탄'},
  {alpha: 'TZ', name: '탄자니아'},
  {alpha: 'TH', name: '태국'},
  {alpha: 'TC', name: '터크스 케이커스 제도'},
  {alpha: 'TG', name: '토고'},
  {alpha: 'TK', name: '토켈라우'},
  {alpha: 'TO', name: '통가'},
  {alpha: 'TM', name: '투르크메니스탄'},
  {alpha: 'TV', name: '투발루'},
  {alpha: 'TN', name: '튀니지'},
  {alpha: 'TR', name: '튀르키예'},
  {alpha: 'TT', name: '트리니다드 토바고'},
  {alpha: 'PA', name: '파나마'},
  {alpha: 'PY', name: '파라과이'},
  {alpha: 'PK', name: '파키스탄'},
  {alpha: 'PG', name: '파푸아뉴기니'},
  {alpha: 'PW', name: '팔라우'},
  {alpha: 'PS', name: '팔레스타인'},
  {alpha: 'FO', name: '페로 제도'},
  {alpha: 'PE', name: '페루'},
  {alpha: 'PT', name: '포르투갈'},
  {alpha: 'FK', name: '포클랜드 제도'},
  {alpha: 'PL', name: '폴란드'},
  {alpha: 'PR', name: '푸에르토리코'},
  {alpha: 'FR', name: '프랑스'},
  {alpha: 'GF', name: '프랑스령 기아나'},
  {alpha: 'TF', name: '프랑스령 남극 지역'},
  {alpha: 'PF', name: '프랑스령 폴리네시아'},
  {alpha: 'FJ', name: '피지'},
  {alpha: 'FI', name: '핀란드'},
  {alpha: 'PH', name: '필리핀'},
  {alpha: 'PN', name: '핏케언'},
  {alpha: 'HM', name: '허드 맥도널드 제도'},
  {alpha: 'HU', name: '헝가리'},
  {alpha: 'HK', name: '홍콩'},
]
